import {get,post} from './base.service'

export default {
  /* 查询问卷列表 */
  querySurveyList(params){
    return get('/app/satisfaction/record/query',{params:params});
  },
  submitSurvey(params){
    return post('/app/satisfaction/record/insert',params)
  }
}



// WEBPACK FOOTER //
// ./src/service/surveyList.service.js